export { default } from "./AvatarGroup.mjs";
export { default as avatarGroupClasses } from "./avatarGroupClasses.mjs";
export * from "./avatarGroupClasses.mjs";